// Probe for a usable WebGL context BEFORE MapLibre touches the DOM.
// Brave's strict fingerprinting protection (or a blocked GPU driver) refuses
// WebGL entirely — map creation would otherwise throw and blank the page.
export function isWebGLAvailable(): boolean {
  try {
    const canvas = document.createElement('canvas')
    const gl = (canvas.getContext('webgl2') ??
      canvas.getContext('webgl')) as WebGLRenderingContext | null
    if (!gl) return false
    // Release the throwaway context immediately — it's only a probe.
    gl.getExtension('WEBGL_lose_context')?.loseContext()
    return true
  } catch {
    return false
  }
}
